import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import SubCategoryOrgServices from 'services/SubCategoryOrgServices';


/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const SubCategoryOrg = ({
    name,
    label,
    value,
    onChange,
    filter,
    required = false,
    validators = [],
    errorMessages = [],
}) => {

    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({ ...filter, search: null })

    useEffect(() => {
        setFilters((prev) => ({ ...prev, ...filter, search: prev.search ?? null }));
    }, [filter]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await SubCategoryOrgServices.getAll({ ...filters });
                const list = res?.data?.view?.data || [];
                const normalized = list.map(item => ({
                    ...item,
                    name: item?.Subcategory?.name || item?.name || '',
                }));

                setData(normalized);
            } catch (error) {
               
            }
        };
        if (filters.organization_id) {
            fetchData();
        }
    }, [filters]);

    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={data.find((item) => item.id === value) || null}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                options={data}
                getOptionLabel={option => option.name || option.name || ''}
                textInputOnChange={(e) => {
                    setFilters({ ...filters, search: e.target.value })
                }}
                //isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.value === value?.value}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
            />
        </div>
    );
};

export default SubCategoryOrg;
